export default "__VITE_ASSET__Cbrwl8q$__"